import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e8f7a8a2")

_pushScopeId("data-v-e8f7a8a2")
const _hoisted_1 = { class: "ui__checkItem_main_cont" }
const _hoisted_2 = {
  key: 1,
  class: "checkItemPicture"
}
const _hoisted_3 = {
  key: 2,
  class: "assistDesc"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_checkTitle = _resolveComponent("checkTitle")
  const _component_checkDescrip = _resolveComponent("checkDescrip")
  const _component_checkContent = _resolveComponent("checkContent")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "ui__checkItem_main",
      id: _ctx.renderData.code
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_checkTitle, {
          itemCode: _ctx.renderData.code,
          titleCont: _ctx.getData("moduleTitle"),
          count: _ctx.getData("itemCount"),
          checkStandardRouter: _ctx.getData("checkStandardRouter")
        }, null, 8, ["itemCode", "titleCont", "count", "checkStandardRouter"]),
        (_ctx.getData('conclusionDesc'))
          ? (_openBlock(), _createBlock(_component_checkDescrip, {
              key: 0,
              renderData: _ctx.renderData.configItems
            }, null, 8, ["renderData"]))
          : _createCommentVNode("", true),
        (_ctx.getData("exampleImage"))
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("img", {
                src: _ctx.getData("exampleImage")
              }, null, 8, ["src"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_checkContent, {
          renderData: _ctx.state.contRenderData
        }, null, 8, ["renderData"]),
        (_ctx.renderData.code === "accident")
          ? (_openBlock(), _createBlock("p", _hoisted_3, "说明：※代表辅助检测项，其缺陷仅供用户参考，不作为事故车的判定依据。"))
          : _createCommentVNode("", true)
      ])
    ], 8, ["id"])
  ]))
})